export function isNumber(str: string | undefined) {
	return !isNaN(Number(str));
}

export function getNumber(str: string | undefined) {
	return isNumber(str) ? Number(str) : -1;
}

export function getGuid() {
	return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
		const r = (Math.random() * 16) | 0,
			v = c === 'x' ? r : (r & 0x3) | 0x8;
		return v.toString(16);
	});
}

export function decodeBase64(str: string) {
	if (str) {
		try {
			str = decodeURIComponent(atob(str));
		} catch (error) {
			console.error('Invalid str format:', error);
		}
	}

	return str;
}

export function isValidEmail(email: string | undefined): boolean {
	if (!email) return false;
	// Simple email regex for basic validation
	const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
	return re.test(email);
}

export function base64ToUint8Array(base64: string): Uint8Array {
	const binary = atob(base64);
	const len = binary.length;
	const bytes = new Uint8Array(len);
	for (let i = 0; i < len; i++) {
		bytes[i] = binary.charCodeAt(i);
	}
	return bytes;
}

export function uint8ToBase64(u8: Uint8Array): string {
	let binary = '';
	const chunkSize = 0x8000; // 32 kB per chunk
	for (let i = 0; i < u8.length; i += chunkSize) {
		const chunk = u8.subarray(i, i + chunkSize);
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		binary += String.fromCharCode.apply(null, chunk as any);
	}
	return btoa(binary);
}

export function normalizeUrlRewriteInput(str: string): string {
	return str.toLowerCase().replace(/[åä]/g, 'a').replace(/ö/g, 'o');
}

export function cleanStringForUrl(str: string): string {
	return normalizeUrlRewriteInput(str)
		.replace(/ /g, '-')
		.replace(/[^\w-]+/g, '') // Remove all non-word chars except hyphens
		.replace(/--+/g, '-') // Replace multiple hyphens with single hyphen
		.replace(/^-+/, '') // Trim hyphens from start
		.replace(/-+$/, ''); // Trim hyphens from end
}

//method for capitalizing the first letter of a string
export function capitalizeFirstLetter(str: string): string {
	if (!str) return str;
	return str.charAt(0).toUpperCase() + str.slice(1);
}
